import { Navigate, Route, Routes, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getToken, getUser, setToken, setUser, type User } from "./api";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ChannelDetail from "./pages/ChannelDetail";

function TopBar({ user, onLogout }: { user: User; onLogout: () => void }) {
  return (
    <div className="topbar">
      <Link to="/" className="brand" style={{ color: "inherit" }}>
        <span className="logo">GD</span>
        <span>GD HUB</span>
      </Link>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span className="muted">{user.email}</span>
        <button className="ghost" onClick={onLogout}>登出</button>
      </div>
    </div>
  );
}

function Protected({ children }: { children: React.ReactNode }) {
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  const [user, setLocalUser] = useState<User | null>(getUser());
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setLocalUser(getUser());
    window.addEventListener("storage", handler);
    window.addEventListener("gd-auth-changed", handler);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener("gd-auth-changed", handler);
    };
  }, []);

  const logout = () => {
    setToken(null);
    setUser(null);
    setLocalUser(null);
    navigate("/login");
  };

  const authed = !!getToken();

  return (
    <div className="app">
      {authed && user && <TopBar user={user} onLogout={logout} />}
      <Routes>
        <Route path="/login" element={authed ? <Navigate to="/" replace /> : <Login onAuth={setLocalUser} />} />
        <Route path="/register" element={authed ? <Navigate to="/" replace /> : <Register onAuth={setLocalUser} />} />
        <Route path="/" element={<Protected><Dashboard /></Protected>} />
        <Route path="/channels/:id" element={<Protected><ChannelDetail /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
